import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventMileage {
	compId: string;
	evCd: string;
	mlgDivi: string;
	mlgGb: string;
	promotionNm: string;
	promotionNo: string;
	mlgStartDt: string;
	mlgEndDt: string;
	mlgSaveKindCd: string;
	mlgSaveKindNm: string;
	mlgPoint: number;
	mlgUnit: string;
	mlgSaveDtCd: string;
	mlgSaveDtNm: string;
	evArriveDt: string;
	stdYear: number;
	stdMonth: number;
	stdDay: number;
	fixSaveDt: string;
	evStartDt: string;
	mlgDeadlineDtCd: string;
	mlgDeadlineDtNm: string;
	stdDeadlineYear: number;
	stdDeadlineMonth: number;
	stdDeadlineDay: number;
	fixDeadlineDt: string;
	adtPrice: number;
	chdPrice: number;
	infPrice: number;
	bafAdtCost: number;
	bafChdCost: number;
	bafInfCost: number;
	airtaxAdtCost: number;
	airtaxChdCost: number;
	airtaxInfCost: number;
	bnrLink: string;
	bnrMstNo: string;
	webBannerLink: "OUTLINK" | "AUTOLINK";
}

/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventMileage";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event/${evCd}/expect-mileage`;
};

/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const eventMileageAsync = (evCd: string) =>
	useConfigureAxios(getPath(evCd), {
		method: "GET",
	});

/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const eventMileageSSR = (evCd: string) =>
	useConfigureAxios(getPath(evCd), {
		method: "GET",
	});

/** ```
 * 예상 포인트적립금 조회
 *   `/pkg/api/event/{evCd}/expect-mileage`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventMileage = (evCd: string, options?: Partial<UseQueryOptions<Response<EventMileage[]>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventMileage;
export {eventMileageAsync, eventMileageSSR, getPath};
export type {EventMileage};
